import { render, staticRenderFns } from "./ul.vue?vue&type=template&id=33423e27&scoped=true"
import script from "./ul.vue?vue&type=script&lang=js"
export * from "./ul.vue?vue&type=script&lang=js"
import style0 from "./ul.vue?vue&type=style&index=0&id=33423e27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33423e27",
  null
  
)

export default component.exports